export interface HeroBanner {
  id: string;
  mediaId: string;
  title: string;
  subtitle: string;
  tag: string;
  image: string;
}

export const heroBanners: HeroBanner[] = [
  {
    id: "b1",
    mediaId: "m002",
    title: "长安夜行",
    subtitle: "盛世之下，藏着一桩无人敢提的旧案。年度古装悬疑口碑之作。",
    tag: "热播剧集",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20city%20at%20night%20with%20rows%20of%20glowing%20lanterns%2C%20misty%20streets%20and%20a%20distant%20palace%20silhouette%2C%20deep%20indigo%20and%20warm%20orange%20tones%2C%20dramatic%20moody%20atmosphere%2C%20epic%20film%20still%20composition%20with%20dark%20areas%20for%20text%20overlay&width=1920&height=900&seq=17c-hero-001&orientation=landscape",
  },
  {
    id: "b2",
    mediaId: "m001",
    title: "星际回响",
    subtitle: "跨越四十光年的信号，让人类重新面对孤独与希望。",
    tag: "热门电影",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20lone%20astronaut%20silhouette%20before%20a%20giant%20ringed%20planet%20and%20soft%20nebula%20glow%2C%20deep%20navy%20and%20amber%20palette%2C%20volumetric%20lighting%2C%20wide%20film%20still%20with%20dark%20negative%20space%20for%20text&width=1920&height=900&seq=17c-hero-002&orientation=landscape",
  },
  {
    id: "b3",
    mediaId: "m009",
    title: "深海来信",
    subtitle: "一封漂流百年的信，带你走进海底的古老城市。",
    tag: "国漫新作",
    image:
      "https://readdy.ai/api/search-image?query=Dreamy%20underwater%20cinematic%20scene%20with%20glowing%20jellyfish%2C%20sunlight%20rays%20piercing%20deep%20blue%20water%20and%20a%20tiny%20child%20diver%20silhouette%2C%20teal%20and%20warm%20gold%20accents%2C%20whimsical%20epic%20wide%20film%20still&width=1920&height=900&seq=17c-hero-003&orientation=landscape",
  },
  {
    id: "b4",
    mediaId: "m007",
    title: "时空旅人",
    subtitle: "如果时间可以倒流，你最想改变哪一天？",
    tag: "浪漫科幻",
    image:
      "https://readdy.ai/api/search-image?query=Ethereal%20cinematic%20scene%20of%20two%20figures%20reaching%20across%20swirling%20time%20portals%20with%20glowing%20light%20trails%2C%20teal%20and%20copper%20palette%2C%20dreamlike%20atmospheric%20wide%20film%20still%20with%20dark%20space%20for%20text&width=1920&height=900&seq=17c-hero-004&orientation=landscape",
  },
];